import { apiWrapper } from 'api';
import { PageNameType } from 'pages/Documentation';

export const getDocumentContent = async (pageName: PageNameType) => {
  const res = await apiWrapper(`/api/v1/datainsight/playground/documentation/${pageName}`, {
    method: 'GET'
  });

  const data = await res.json();
  return data.data;
};
